import moment from "moment";
import { DownloadLinkEnh } from "../../../../../../components/common/DownloadLink/DownloadLinkEnh";

const ExistingFileDetails = ({ berkasSidang }) => {
  return (
    <div className="flex flex-col overflow-auto">
      <div className="flex flex-row gap-2">
        <div className="flex-none basis-1/5 font-bold">Berkas</div>
        <div>:</div>
        <div>
          {berkasSidang ? (
            <DownloadLinkEnh 
              endpoint={`/file/berkas/get/${berkasSidang.nama_berkas}/`}
              label={"Unduh"}
            />
          ) : (
            "-"
          )}
        </div>
      </div>
      <div className="flex flex-row gap-2">
        <div className="flex-none basis-1/5 font-bold">Waktu unggah</div>
        <div>:</div>
        <div>
          {berkasSidang
            ? moment(berkasSidang.timestamp).format("DD/MM/YYYY HH:mm:ss")
            : "-"}
        </div>
      </div>
    </div>
  );
};

export default ExistingFileDetails;
